module.exports = __webpack_public_path__ + "static/img/wx.3b418e98.svg";